import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevatingYourKansasCityInvestments from "./sections/ElevatingYourKansasCityInvestments";
import LocalExpertiseGlobalStandards from "./sections/LocalExpertiseGlobalStandards";
import OurCoreManagementSolutions from "./sections/OurCoreManagementSolutions";
import WhyKcInvestorsChooseUs from "./sections/WhyKcInvestorsChooseUs";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import KansasCityRentalMarketInsights from "./sections/KansasCityRentalMarketInsights";
import StartYourConsultation from "./sections/StartYourConsultation";
import InvestKcFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevatingYourKansasCityInvestments />
      <LocalExpertiseGlobalStandards />
      <OurCoreManagementSolutions />
      <WhyKcInvestorsChooseUs />
      <WhatOurClientsSay />
      <KansasCityRentalMarketInsights />
      <StartYourConsultation />
      <InvestKcFooter />
    </div>;
}